
import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';
import { DateTime } from 'luxon';



export const Decision: ITypeSpecificPolicy<types.Decision> = {


  fields: {

    dueDate: dateTimeFieldPolicy(),
    isComplete: {
      read: (existing, { readField }) => {
        const decision = readField('approved');

        if (decision === null) {
          return false;
        }
        return true;
      }
    },
    isOverdue: {
      read: (existing, { readField }) => {
        const doesNotHaveDecision = readField('approved');

        const dueDate = readField<string>('dueDate');
        if (!dueDate) {
          return false;
        }

        const daysTillDueDate = DateTime.fromISO(dueDate).diffNow('days').days;

        const isPastDue = daysTillDueDate <= 0
          ? true
          : false;


        if (doesNotHaveDecision === null && isPastDue) {
          return true;
        }
        return false;
      }
    },
    isDueSoon: {
      read: (existing, { readField }) => {
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
        const decision = readField('approved');
        const dueDate = readField<string>('dueDate');
        if (!dueDate) {
          return false;
        }

        const daysTillDueDate = DateTime.fromISO(dueDate).diffNow('days').days;

        const isDueSoon = daysTillDueDate <= 7 && daysTillDueDate >= 0
          ? true
          : false;
        return isDueSoon;
      }
    }
  }


};
